export default __webpack_public_path__ + "621ed93a6bbc2b5b7be49311b7b8f6f5.png";